import { OperacionGenericaDto } from "./operacionGenericaDto.model";

export class OperacionAlegacionDto extends OperacionGenericaDto {
  alegacion: String = null;
  fechaAlegacion: Date  = null;
}
